import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { Quote, Star, BadgeCheck } from 'lucide-react';
const testimonials = [{
  name: 'Ana',
  age: '36 años',
  headline: 'Mis vaqueros favoritos',
  quote: 'Por fin cerré mis vaqueros favoritos sin sentir que me apretaban a media tarde. Es una sensación que llevaba años sin tener.',
  initial: 'A'
}, {
  name: 'Lucía',
  age: '42 años',
  headline: 'Adiós a la pesadez',
  quote: 'La pesadez desapareció en la primera semana. Disfruto otra vez las cenas con amigas sin pensar en cómo voy a llegar a casa.',
  initial: 'L'
}, {
  name: 'Sara',
  age: '34 años',
  headline: 'Energía de verdad',
  quote: '¡Me siento con mucha más energía! Llego al final del día sin ese bajón de las tardes y con ganas de hacer cosas, no solo de tumbarme.',
  initial: 'S'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.15
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 24
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function Testimonials() {
  return <section className="py-24 md:py-32 bg-olive" data-id="element-250">
      <div className="container mx-auto px-6 max-w-6xl" data-id="element-251">
        <div className="text-center mb-16 md:mb-20 max-w-3xl mx-auto" data-id="element-252">
          <span className="text-salvia font-semibold tracking-[0.25em] text-xs uppercase mb-4 block" data-id="element-253">
            Lo que dicen de nosotros
          </span>
          <h2 className="font-serif text-4xl md:text-5xl font-semibold tracking-tight text-forest leading-[1.1]" data-id="element-254">
            Más de{' '}
            <span className="text-forest/70 italic font-normal" data-id="element-255">
              1.200 mujeres
            </span>{' '}
            ya han transformado su digestión con GUT LABS
          </h2>
        </div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8" data-id="element-256">
          {testimonials.map((t, i) => <motion.figure key={i} variants={itemVariants} className="bg-white rounded-3xl p-8 md:p-9 shadow-sm border border-salvia/25 flex flex-col" data-id="element-257">
              <Quote className="w-7 h-7 text-salvia/70 mb-4" strokeWidth={2} data-id="element-258" />

              <h3 className="font-serif text-lg md:text-xl font-semibold tracking-tight text-forest mb-3" data-id="element-259">
                {t.headline}
              </h3>

              <blockquote className="text-base text-forest/80 leading-relaxed font-medium mb-6 flex-grow" data-id="element-260">
                "{t.quote}"
              </blockquote>

              <div className="flex items-center gap-1 mb-5" data-id="element-261">
                {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-salvia text-salvia" data-id="element-262" />)}
              </div>

              <figcaption className="flex items-center gap-3 pt-5 border-t border-salvia/20" data-id="element-263">
                <div className="w-12 h-12 rounded-full bg-salvia/20 flex items-center justify-center text-forest font-bold text-lg shrink-0" data-id="element-264">
                  {t.initial}
                </div>
                <div className="min-w-0 flex-1" data-id="element-265">
                  <div className="text-sm font-bold text-forest tracking-tight" data-id="element-266">
                    {t.name}
                  </div>
                  <div className="flex items-center gap-1.5 mt-1" data-id="element-267">
                    <span className="text-xs text-forest/55 font-medium" data-id="element-268">
                      {t.age}
                    </span>
                    <span className="text-forest/20" data-id="element-269">·</span>
                    <span className="inline-flex items-center gap-1 bg-cream text-forest text-[10px] font-bold tracking-tight px-1.5 py-0.5 rounded" data-id="element-270">
                      <BadgeCheck className="w-3 h-3" strokeWidth={2.5} data-id="element-271" />
                      <span data-id="element-272">Compradora Verificada</span>
                    </span>
                  </div>
                </div>
              </figcaption>
            </motion.figure>)}
        </motion.div>
      </div>
    </section>;
}